import qs from 'query-string';
import cookies from 'js-cookie';

const initAppAction = ({ commit }, payload ) => {
    if(!payload.cookieAccepted) {
        payload.cookieAccepted = cookies.get('cookieyes-consent') ? cookies.get('cookieyes-consent').includes('functional:yes') : false;
    }
    commit('setState', payload)
}

const setUrlAction = ({ state }) => {
    const params = {
        view: state.listView,
        zoom: state.zoom,
        lat: state.position.lat,
        lng: state.position.lng,
        page: state.page,
    }
    if(state.selected) {
        params.selected = state.selected;
    }

    Object.keys(state.filters).forEach(key => {
        const filter = state.filters[key];
        if(filter.options) {
            const selected = filter.options.filter(option => option.selected);
            if(selected.length) {
                params[key.substring(0, 1)] = selected.map(f => f.value).join(',')
            }
        }
    });

    const url = `${window.location.protocol}//${window.location.host + window.location.pathname}?${qs.stringify(params)}`;
    window.history.replaceState({}, document.title, url);
}

const resetMapAction = ({ commit, state }) => {
    commit('setZoom', state.defaultZoom);
    commit('setPosition', state.defaultPosition);
}

const actions = {
    initApp: initAppAction,
    setUrl: setUrlAction,
    resetMap: resetMapAction,
};

export default actions;